import React from "react";

// Header component to appear at the top of each page
const Header = () => (
	<div>
		<header>
			<h1>Table Tennis Tournament Generator</h1>
		</header>
	</div>
);

export default Header;